import React, {useEffect, useMemo, useState} from "react";
import useResizeObserver from "use-resize-observer";

import PropTypes from "prop-types";

const ScrollBar = props => {

    const { ref: resizeRef, width: resizeWidth, height: resizeHeight } = useResizeObserver();

    const [currentIndex, setCurrentIndex] = useState(isNaN(props.currentIndex) ? 0 : props.currentIndex);
    const [maxHeight, setMaxHeight] = useState('unset');

    const scroll = async (direction) => {
        let toIndex = currentIndex + direction;

        if(TB.isDefined(props.onScroll) && TB.isDefined(props.currentIndex)) {
            let toIndex = props.currentIndex + direction;
            if (props.infinite) {
                if (toIndex < 0) {
                    toIndex = props.children.length - 1;
                }else if (toIndex >= props.children.length) {
                    toIndex = 0;
                }
            }
            return props.onScroll(toIndex);
        }

        let scrollLeft = (direction === 1) ? '+=' : '-=';

        scrollLeft += props.itemWidth || (resizeWidth + 'px');

        let increaseHeight = false;

        let height = document.getElementById(props.target + '-' + toIndex)?.clientHeight || undefined;
        if (props.handleHeight) {
            if (height && height > maxHeight) {
                increaseHeight = true;
                setMaxHeight(height + 120);
            }
        }
        $('#' + props.target).animate({scrollLeft}, 800, "linear");
        if (props.handleHeight) {
            if (height && !increaseHeight) {
                await TB.wait(800);
                setMaxHeight(height + 120);
            }
        }


        if (toIndex < 0 || toIndex >= props.children.length) {
            return;
        }
        if (TB.isDefined(props.onScroll)) {
            props.onScroll(toIndex);
        }
        setCurrentIndex(toIndex);
    };

    useEffect(() => {
        if (TB.isDefined(props.currentIndex)) {

            let target = document.getElementById(props.target + '-' + props.currentIndex);

            if (target && TB.isDefined(target.offsetLeft)) {
                $('#' + props.target).animate({scrollLeft: target.offsetLeft}, props.duration || 800, "linear");
            }
        }
    }, [props.currentIndex]);

    const checkOverflow = (width = 0) => {
        let item = props.itemWidth || resizeWidth;
        return width < (item * props.children?.length)
    }
    const itemsOverflowContainer = useMemo(() => checkOverflow(resizeWidth),[resizeWidth])

    return (
        <div ref={resizeRef} style={{height: maxHeight, transition: 'height 150ms ease-in'}}>
            <div id={props.target} key={'scrollbar-items-' + props.target}>
                {React.Children.map(props.children, (child, cIndex) => {

                    // let isLastChild =  index !== 0 && TB.isInteger(totalVisibleItems / (index +1))

                    return React.cloneElement(child, {
                        id: props.target + '-' + cIndex
                    });
                })}
            </div>
            {!props.hideScroll && TB.isDefined(props.children) && props.children.length > 1 && itemsOverflowContainer && (
                <div className={"scroller " + props.target + "-scroller"}
                     key={'scrollbar-scroller-' + props.target}>
                    <button
                        key={'left' + props.target}
                        disabled={(!props.infinite && props.currentIndex === 0) || props.disabled}
                        className={'btn btn-sm left-scroll'}
                        onClick={() => scroll(-1)}>
                        <i className={'fa fa-caret-left'}/>
                    </button>

                    <button
                        key={'right' + props.target}
                        className={'btn btn-sm right-scroll'}
                        disabled={(!isNaN(props.currentIndex) && !props.infinite && ((props.currentIndex + 1) >= props.children.length)) || props.disabled}
                        onClick={() => scroll(1)}>

                        <i className={'fa fa-caret-right'}/>

                    </button>
                </div>
            )}
            {!props.hideScroll && !props.itemWidth && props.showPagination && TB.isDefined(props.children) && props.children.length > 1 && (
                <div className={"scroller " + props.target + "-pagination"}
                     key={'scrollbar-pagination-' + props.target}>
                    <p>
                        {props.label ? props.label : 'Item'} <span className="current-page">{(currentIndex + 1)}</span> of {props.children.length}
                    </p>
                </div>
            )}
        </div>
    )
};

ScrollBar.propTypes = {
    label: PropTypes.string,
    itemWidth: PropTypes.any,
    target: PropTypes.string,
    currentIndex: PropTypes.any,
    onScroll:PropTypes.any,
    infinite: PropTypes.any
}

export default ScrollBar;